import { render, staticRenderFns } from "./OrgEdit.vue?vue&type=template&id=2f95e580&scoped=true"
import script from "./OrgEdit.vue?vue&type=script&lang=js"
export * from "./OrgEdit.vue?vue&type=script&lang=js"
import style0 from "./OrgEdit.vue?vue&type=style&index=0&id=2f95e580&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f95e580",
  null
  
)

export default component.exports